import { createFileRoute } from "@tanstack/react-router";
import { confirmationPages } from "@/data/confirmations";
import { seo } from "@/lib/seo";
import ConfirmationPage from "@/pages/ConfirmationPage";

export const Route = createFileRoute("/_site/confirm/$slug")({
  head: ({ params }) => {
    const page = confirmationPages.find(
      (p) => p.slug === params.slug || p.oldSlugs.includes(params.slug),
    );
    // Confirmation pages are post-submission thank-you pages: useful to the
    // visitor, never something we want in search results.
    return seo({
      title: page?.metaTitle ?? "Thank You | Kodiak Structures & Exteriors",
      description: page?.metaDescription,
      path: `/confirm/${params.slug}`,
      noindex: true,
    });
  },
  component: ConfirmationPage,
});
